import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MarketInfoService {
    private baseURL: string;
    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    getMarketDaysSettings(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/MarketInfo/GetMarketDaysSettings`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body as any;;
                }),
                catchError(this.handleError)
            );
    }

    GetAllMarkets(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/MarketInfo`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body as any;;
                }),
                catchError(this.handleError)
            );
    }

    getMarketList(): Observable<boolean> {
        return this.http.get<any>(
            `${this.baseURL}/MarketInfo/GetMarketList`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const marketInfo = res.body as any;
                    return marketInfo;
                }),
                catchError(this.handleError)
            );
    }

    getMarketCount(): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.baseURL}/MarketInfo/GetCurrentMarketCount`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const timeZones = res.body as any[];
                    return timeZones;
                }),
                catchError(this.handleError)
            );
    }

    getRentalType(): Observable<string> {
        return this.http.get(
            `${this.baseURL}/MarketInfo/GetMarketRentalTypes`,
            { responseType: 'text' }
        ).pipe(
            map(res => res as string),
            catchError(this.handleError)
        );
    }

    getMarketName(): Observable<string> {
        return this.http.get(
            `${this.baseURL}/MarketInfo/GetMarketName`,
            { responseType: 'text' }
        ).pipe(
            map(res => res as string),
            catchError(this.handleError)
        );
    }

    getMarketSettings(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/MarketInfo/GetMarketSettings`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body as any;;
                }),
                catchError(this.handleError)
            );
    }

    saveMarketSettings(data: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/MarketInfo/SaveMarketSettings`,
            data,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    saveMarketLogo(data: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/MarketInfo/SaveMarketLogo`,
            data,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    getMarketTimeZones(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/MarketInfo/GetMarketTimeZones`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body as any;;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}